import { MAX_LINE_ITEM_QUANTITY } from '../constants/CRM';
import { BillingConversionError } from '../public/types';
import { getDateDifference, getUTCDate } from './dateTime';
export function getObjectConversionValidation(object, supportedCurrencies) {
  const validationErrors = new Set();
  if (!object) {
    validationErrors.add(BillingConversionError.OBJECT_NOT_FOUND);
    return validationErrors;
  }
  const currencyCodes = new Set(object.lineItems.map(li => li.currencyCode));
  if (currencyCodes.size > 1) {
    validationErrors.add(BillingConversionError.MULTIPLE_CURRENCIES);
  }
  const supportedCurrencyCodes = new Set(supportedCurrencies.map(currency => currency.currencyCode));

  // no currency set
  if (!object.currencyCode) {
    validationErrors.add(BillingConversionError.NO_CURRENCY);
  }

  // currency not supported
  if (object.currencyCode && !supportedCurrencyCodes.has(object.currencyCode)) {
    validationErrors.add(BillingConversionError.UNSUPPORTED_CURRENCY);
  }

  // currency for line item is not supported or unset
  if ([...currencyCodes].some(code => !code || !supportedCurrencyCodes.has(code))) {
    validationErrors.add(BillingConversionError.UNSUPPORTED_CURRENCY);
  }
  const today = getUTCDate();
  for (const li of object.lineItems) {
    if (li.startDate && getDateDifference(today, li.startDate) < 0) {
      validationErrors.add(BillingConversionError.PAST_START_DATE);
    }
    // relative start date
    // https://tools.hubteam.com/puma/objects/LINE_ITEM/properties/hs_billing_start_delay_type/details/0
    if (li.startDateDelayType && (li.startDateDelayType === 'hs_billing_start_delay_days' || li.startDateDelayType === 'hs_billing_start_delay_months')) {
      validationErrors.add(BillingConversionError.RELATIVE_START_DATE);
    }
    if (li.billingFrequency && (li.billingFrequency === 'per_five_years' || li.billingFrequency === 'per_four_years' || li.billingFrequency === 'per_three_years' || li.billingFrequency === 'per_two_years')) {
      validationErrors.add(BillingConversionError.MULTI_YEAR_BILLING_FREQUENCY);
    }

    // future start date for one time Li (billingFrequency for one time is '' or null)
    if (!li.billingFrequency && li.startDate && getDateDifference(today, li.startDate) > 0) {
      validationErrors.add(BillingConversionError.FUTURE_ONE_TIME_LINE_ITEM);
    }

    // fractional quantity
    if (li.quantity % 1 !== 0) {
      validationErrors.add(BillingConversionError.FRACTIONAL_QUANTITY);
    }

    // large quantity
    if (li.quantity > MAX_LINE_ITEM_QUANTITY) {
      validationErrors.add(BillingConversionError.LARGE_QUANTITY);
    }
  }
  return validationErrors;
}